import { IconButton } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import { useNatureOfBusinessForm } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider';
import { useDisclosure } from '@hooks/useDisclosure';
import ExportIncomeModal from '../ExportIncomeModal/ExportIncomeModal';
import { IIncomeStructureFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';

type ExportIncomeEditButtonProps = {
  keyItem: string;
};

const ExportIncomeEditButton = ({ keyItem }: ExportIncomeEditButtonProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, watch } = useNatureOfBusinessForm();

  const completedSection = watch(
    'incomeStructure.completedSection'
  ) as IIncomeStructureFormValues['completedSection'];
  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  const exportIncomeItems = getValues(
    'incomeStructure.exportIncomeItems'
  ) as IIncomeStructureFormValues['exportIncomeItems'];
  const editData = exportIncomeItems[keyItem].incomeCategory;

  return (
    <>
      <IconButton
        color="inherit"
        size="small"
        sx={{ padding: 0 }}
        onClick={open}
        disabled={isCompletedTh || isCompletedEn}
      >
        <EditOutlinedIcon style={{ fontSize: '14px' }} />
      </IconButton>
      {opened && (
        <ExportIncomeModal
          mode="edit"
          open={opened}
          close={close}
          keyItem={keyItem}
          editData={editData}
        />
      )}
    </>
  );
};

export default ExportIncomeEditButton;
